module.exports = __webpack_public_path__ + "7d088296/img/grid-web-icon.d0395d64.svg";